import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Cell } from './cell.model';

@Component({
  selector: 'app-grid-list',
  templateUrl: './grid-list.component.html',
  styleUrls: ['./grid-list.component.scss']
})
export class GridListComponent implements OnInit {
  @Input('data') data;
  @Input('isEditable') isEditable:boolean;
  @Input('isShortVersionNeeded') isShortVersionNeeded: boolean;
  @Output('modelChanged') modelChanged: EventEmitter<any> = new EventEmitter();

  cols: number;
  cells: Cell[];

  constructor() {
  }

  ngOnInit() {
    this.initCells();
  }

  initCells() {
    this.cells = [];

    if (this.data.switchColWithRow) {
      this.cols = this.data.rowHeaders.length + 1;

      this.data.rowHeaders.forEach(x => {
        this.cells.push(new Cell(x.id, 0, 'labelText',this.isEditable));
      });

      this.data.colHeaders.forEach(x => {
        this.cells.push(new Cell(0, x.id, 'labelText',this.isEditable));
        this.data.matrix.forEach(c => {
          if (c[this.data.colProp] == x.id) {
            this.cells.push(new Cell(c[this.data.colProp], c[this.data.rowProp],'inputNumber',this.isEditable));
          }
        })
      });
    }
    else {
      this.cols = this.data.colHeaders.length + 1;

      this.data.colHeaders.forEach(x => {
        this.cells.push(new Cell(x.id, 0, 'labelText',this.isEditable));
      });

      this.data.rowHeaders.forEach(x => {
        this.cells.push(new Cell(0, x.id, 'labelText',this.isEditable));
        this.data.matrix.forEach(c => {
          if (c[this.data.rowProp] == x.id) {
            this.cells.push(new Cell(c[this.data.colProp], c[this.data.rowProp],'inputNumber',this.isEditable));
          }
        })
      });
    }

    this.cells.forEach(c => {
      c.value = this.getCellValue(c.colId,c.rowId);
    });
  }

  getCellValue(colId, rowId) {
    if (colId > 0 && rowId > 0) {
      let result = this.data.matrix.filter(x => { return x[this.data.colProp] == colId && x[this.data.rowProp] == rowId })[0].value;
      return result;
    }
    else if (colId > 0 && rowId == 0) {
      if (this.data.switchColWithRow == false) {
        let result = this.data.colHeaders.filter(x => { return x.id == colId })[0].value;;
        return result;
      }
      else {
        let result = this.data.rowHeaders.filter(x => { return x.id == colId })[0].value;;
        return result;
      }
    }
    else if (colId == 0 && rowId > 0) {
      if (this.data.switchColWithRow == false) {
        let result = this.data.rowHeaders.filter(x => { return x.id == rowId })[0].value;;
        return result;
      }
      else {
        let result = this.data.colHeaders.filter(x => { return x.id == rowId })[0].value;;
        return result;
      }
    }
  }

  updateMatrix(cell) {
    let item = this.data.matrix.find(x => x[this.data.colProp] == cell.colId && x[this.data.rowProp] == cell.rowId);
    item.value = Number(cell.value);
    this.modelChanged.emit();
  }
}
